import DOMPurify from "isomorphic-dompurify";

const lazyContentElements = document.querySelectorAll("[data-lazy-content-uri]");
Array.from(lazyContentElements).forEach((item) => {
    fetch(item.dataset.lazyContentUri)
        .then((res) => {
            return res.text();
        })
        .then((html) => {
            item.innerHTML = DOMPurify.sanitize(html);
            item.dataset.lazyContentUri = "";
        });
});
